import './tooltip.scss';
import tippy, { followCursor } from 'tippy.js';

class Tooltip {
    constructor (element) {
        this.$brandFilter = element;
        this.$toolTipItems = this.$brandFilter.querySelectorAll('[data-tooltip-item]');
    }

    initialize () {
        this.$toolTipItems.forEach(function (item) {
            const copy = item.getAttribute('data-tooltip-copy');
            tippy(item, {
                followCursor: true,
                plugins: [followCursor],
                content: copy,
                arrow: false
            });
        });
    }
}

export { Tooltip };
